import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import ReactDatetime from "react-datetime";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
} from "react-bootstrap"
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';



const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }else{
      event.preventDefault();
      onApplyChanges();
    }

    setValidated(true);
    
  };

  useEffect(() => {
    setValidated(false);
  }, []);

  return (
    <Modal
      show={open}
      onHide={onCancelChanges}
      backdrop="static"
      keyboard={false}
    >
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>Score Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="validationCustom01">
          <Form.Label>Score Name</Form.Label>
            <Form.Control
              name="SCORE_NAME"
              value={row.SCORE_NAME}
              required
              onChange={onChange}
            />
          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="validationCustom02">
          <Form.Label>Status</Form.Label>
          <Form.Control as="select"
            name="SCORE_STATUS"
            value={row.SCORE_STATUS ?? ''}
            onChange={onChange}
            required
          >
            <option value=''>Select Status...</option>
            <option value="Active">Active</option>
            <option value="InActive">InActive</option>
            
          </Form.Control>
          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
        </Form.Group>

        <Form.Group controlId="validationCustom02">
          <Form.Label>Calculate</Form.Label>
          <Form.Control as="select"
            name="SCORE_CALCULATE"
            value={row.SCORE_CALCULATE ?? ''}
            onChange={onChange}
            required
          >
            <option value=''>Select Calculate...</option>
            <option value="1">YES</option>
            <option value="0">NO</option>
            
          </Form.Control>
          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
        </Form.Group>
          
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelChanges}>
          Cancel
        </Button>
        <Button variant="primary" type="submit" >Save</Button>
      </Modal.Footer>
      </Form>
    </Modal>
  )
};

export default Popup;